import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import TeamTrainingMatterLineScheduleInstructorModalLine from './TeamTrainingMatterLineScheduleInstructorModalLine';
class TeamTrainingMatterLineScheduleInstructorModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      date_start: null,
      date_finish: null,
      lista_dificuldades: [],
      lista_instrutores: [],
      lista_assuntos: [],
      dificuldades: [],
      setting_level_id: null,
      staff_id: null,
      matter_subject_id: null,
      instructor_date_start: null,
      instructor_date_finish: null,
      exam_start: null,
      materia: {},
      modal: false,
    };

    this.adicionarInstrutor = this.adicionarInstrutor.bind(this);
    this.openModal = this.openModal.bind(this);
    this.export = this.export.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

    handleSelectChangeInstrutor(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.materia.id !== 'undefined' && this.state.loaded === 0) {
      this.setState({materia: newProps.materia});
      this.setState({loaded: 1});
    }
    if(Array.isArray(newProps.materia.staff_matter)) {
      this.setState({lista_instrutores: newProps.materia.staff_matter});
    }
    if(Array.isArray(newProps.materia.staff_subject)) {
      this.setState({lista_assuntos: newProps.materia.staff_subject});
    }
  }

  openModal() {
    this.setState({ modal: true });
  }

  export(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var self = this;
    var url = "/exportar/programacao/aula/" + event.currentTarget.value;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.props.handleAlert("", "", 'closed');
      });
    });
  }

  adicionarInstrutor(event) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      team_training_matter_id: this.state.materia.id,
      staff_id: this.state.staff_id,
      local: this.state.local,
      class_number: this.state.class_number,
      matter_subject_id: this.state.matter_subject_id,
      instructor_date_start: this.state.instructor_date_start,
      instructor_date_finish: this.state.instructor_date_finish,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/instrutor', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.refreshData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deletar (team_training_matter_staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse instrutor?');
    if (confirm) {
    this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/instrutor/' + team_training_matter_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
      <div>
        <button className="btn btn-sm btn-primary" onClick={() => { self.openModal() }}><i className="fa fa-fw fa-check"></i> Programação de aula</button>
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
          <Modal.Header className='modal-prova'>
            <div className="row">
              <div className="col-md-6">
                  <h4 className="pull-left"><b>Adicionar instrutor:</b></h4>
              </div>
              <div className="col-md-6">
                <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
                <i className="fa fa-fw fa-close"></i></button>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className='modal-instrutor'>
            <div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Início:</label>
                    <InputMask required value={this.state.instructor_date_start}  maskChar={null} name="instructor_date_start " mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'instructor_date_start')} placeholder="dd/mm/yyyy hh:mm" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Fim:</label>
                    <InputMask required value={this.state.instructor_date_finish}  maskChar={null} name="instructor_date_finish " mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'instructor_date_finish')} placeholder="dd/mm/yyyy hh:mm" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Instrutor:</label>
                    <Select
                      className="small-font-input"
                      name="staff_id"
                      value={this.state.staff_id}
                      searchable={true}
                      placeholder={'Selecionar instrutor'}
                      onChange={this.handleSelectChangeInstrutor.bind(this, 'staff_id')}
                      options={this.state.lista_instrutores}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assunto:</label>
                    <Select
                      className="small-font-input"
                      name="matter_subject_id"
                      value={this.state.matter_subject_id}
                      searchable={true}
                      placeholder={'Selecionar assunto'}
                      onChange={this.handleSelectChangeInstrutor.bind(this, 'matter_subject_id')}
                      options={this.state.lista_assuntos}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Local:</label>
                    <input type="text" name="local" className="form-control" placeholder="Local" value={this.state.local} onChange={this.handleChange.bind(this, 'local')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Sala:</label>
                    <input type="text" name="class_number" className="form-control" placeholder="Ńúmero da sala" value={this.state.class_number} onChange={this.handleChange.bind(this, 'class_number')} />
                  </div>
                </div>
              </div>
              <button className="btn btn-block btn-lg btn-primary" onClick={() => { self.adicionarInstrutor() }}><i className="fa fa-fw fa-check"></i> Adicionar instrutor</button>
              <hr/>
              <table className="table table-bordered table-stripped table-hover">
                <thead>
                  <tr>
                    <th style={{ width: "20%"}}>Instrutores</th>
                    <th style={{ width: "20%"}}>Assuntos</th>
                    <th style={{ width: "12%"}}>Locais</th>
                    <th style={{ width: "8%"}}>Salas</th>
                    <th style={{ width: "14%"}}>Início</th>
                    <th style={{ width: "14%"}}>Término</th>
                    <th style={{ width: "12%"}}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                    {Object.keys(self.props.materia.team_training_matter_staff).map(function(i) {
                      return (
                        <TeamTrainingMatterLineScheduleInstructorModalLine RequestApi={self.props.RequestApi} refreshData={self.props.refreshData} handleAlert={self.props.handleAlert} team_data={self.props.team_data} team_id={self.props.team_id} lista_instrutores={self.state.lista_instrutores} lista_assuntos={self.state.lista_assuntos} instrutor={self.props.materia.team_training_matter_staff[i]} />
                      );
                    })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className='modal-prova'>
            <div className="row">
              <div className="col-md-6">
              </div>
              <div className="col-md-6">
                <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
                <i className="fa fa-fw fa-close"></i></button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TeamTrainingMatterLineScheduleInstructorModal;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTrainingMatterLineScheduleInstructorModal.js